export default __webpack_public_path__ + "static/media/find_car_background.f3dc7263.png";